import { API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function consultFeeRetrieve(consultId) {
  return {
    types: [
      ACTION_TYPES.CONSULT_PRICE_RETRIEVE_REQUESTED,
      ACTION_TYPES.CONSULT_PRICE_RETRIEVE_SUCCEED,
      ACTION_TYPES.CONSULT_PRICE_RETRIEVE_FAILED,
    ],
    promise: client => client.get(`/consults/${consultId}/consult-fee`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function consultFeeEstimate(consultId, consultDiscount = 0) {
  return {
    types: [
      ACTION_TYPES.CONSULT_FEE_ESTIMATE_REQUESTED,
      ACTION_TYPES.CONSULT_FEE_ESTIMATE_SUCCEED,
      ACTION_TYPES.CONSULT_FEE_ESTIMATE_FAILED,
    ],
    promise: client =>
      client.get(`/consults/${consultId}/consult-fee/estimate?consult_discount=${consultDiscount}`),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function consultFeeUpdate(consultId, body) {
  return {
    types: [
      ACTION_TYPES.CONSULT_PRICE_UPDATE_REQUESTED,
      ACTION_TYPES.CONSULT_PRICE_UPDATE_SUCCEED,
      ACTION_TYPES.CONSULT_PRICE_UPDATE_FAILED,
    ],
    promise: client => client.patch(`/consults/${consultId}/consult-fee`, body),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function consultFeeResetState() {
  return {
    type: ACTION_TYPES.CONSULT_PRICE_RESET,
    payload: {},
  };
}
